"use strict";

import React from 'react';
import NavListItem from "./NavListItem";
import {NavLink} from "react-router-dom";

function NavList(props) {
    const {className='nav', navList=[]} = props;
    return (
        <ul className={`${className}__list`}>
            {navList.map((listItem, index)=> {
                return ( <NavListItem
                    key={`mainNavListItem-${index}`}
                    className={`${className}__list`}
                    item={listItem}/> )
            })}
        </ul>
    );
}

export default NavList;